import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnDestroy,
  Output,
} from '@angular/core'
import {NotificationService} from '@app/core/services/notification.service'
import {Observable, Subject} from 'rxjs'

@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-table-export',
  template: `
    <button type="button" class="dropdown-item" (click)="exportToCsv()">
      <i class="fa fa-download fa-fw text-dark" aria-hidden="true">&nbsp;</i
      >Export CSV
    </button>
  `,
  standalone: false,
})
export class TableExportComponent implements OnDestroy {
  @Input() tableData: Observable<any[]> = new Observable<any[]>()
  @Input() fileName: string
  @Output() prepareData = new EventEmitter()
  destroy$ = new Subject<boolean>()

  constructor(private notify: NotificationService) {}

  // TSF -> is NOT tab seperated !Falues -> Terminal Settings File -> this is an XML notation we wont use.
  exportToTsf() {
    this.prepareData.emit()

    const tsfRows = []
    const header = this.extractHeader(this.tableData[0])
    tsfRows.push(header.join('\t'))

    this.tableData.forEach((row) => {
      const flattenedRow = this.flattenObject(row)
      const values = header.map((field) => flattenedRow[field] || '')
      tsfRows.push(values.join('\t'))
    })

    const tsfString = tsfRows.join('\n')
    const blob = new Blob([tsfString], {type: 'text/tsv;charset=utf-8;'})

    const link = document.createElement('a')
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', this.fileName + '.tsf')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  exportToCsv() {
    this.prepareData.emit()
    setTimeout(() => {
      this.tableData.pipe().subscribe((data) => {
        const csvRows = []
        const header = this.extractHeader(data[0])
        csvRows.push(header.join(','))
        data.forEach((row) => {
          const flattenedRow = this.flattenObject(row)
          const values = header.map((field) => flattenedRow[field] || '')
          csvRows.push(values.join(','))
        })
        const csvString = csvRows.join('\n')
        const blob = new Blob([csvString], {type: 'text/csv;charset=utf-8;'})
        const link = document.createElement('a')
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', this.fileName + '.csv')
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
        this.notify.info('Exported ' + data.length + ' items to CSV')
      })
    }, 1000)
  }

  private extractHeader(obj: any): string[] {
    const header = []
    for (const key in obj) {
      if (typeof obj[key] !== 'object') {
        header.push(key)
      } else {
        const nestedHeader = this.extractHeader(obj[key])
        header.push(...nestedHeader.map((nestedKey) => `${key}.${nestedKey}`))
      }
    }
    return header
  }

  private flattenObject(obj: any, prefix: string = ''): any {
    const flattened = {}
    for (const key in obj) {
      if (typeof obj[key] !== 'object') {
        flattened[prefix + key] = obj[key]
      } else {
        Object.assign(
          flattened,
          this.flattenObject(obj[key], prefix + key + '.'),
        )
      }
    }
    return flattened
  }

  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
